import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { v4 as uuidv4 } from "uuid";
import { EventMap } from "../NodeEvents";

export class EventNodeModel extends DefaultNodeModel {
  constructor({
    id = `EventNode_${uuidv4()}`,
    color = "rgb(42, 189, 44)",
    position = { x: 100, y: 100 },
    nodeProperties = { Name: "New Event", Type: "Event", Event: "" },
  }) {
    super({
      id: id,
      name: nodeProperties.Name,
      color: color,
      extras: { properties: nodeProperties },
    });
    this.setPosition(position.x, position.y);

    if (nodeProperties.Event) {
      const inPorts = EventMap.find((item) => item.Name === nodeProperties.Event)?.In;
      inPorts.forEach((item) => {
        this.addInPort(item);
      });
      const outPorts = EventMap.find((item) => item.Name === nodeProperties.Event)?.Out;
      outPorts.forEach((item) => {
        this.addOutPort(item);
      });
    }
  }
}
